const useView = (viewName, user) => {
  const viewData = user?.views?.[viewName] || {};

  return viewData;
};

export default useView;
